import React from "react";
import emptyDashboardImg from "assets/images/empty-dashboard.png";
import { Typography } from "components";

const EmptyDashboard = () => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ paddingTop: "6rem" }}
    >
      <img src={emptyDashboardImg} alt="Transactions Loading" />
      <Typography className="mt-4" state="primary">
        Recent Transactions will be loaded soon...
      </Typography>
    </div>
  );
};

export default EmptyDashboard;
